import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.822764 16C0.612 16 0.401236 15.9198 0.241103 15.7585C-0.0803677 15.437 -0.0803677 14.9159 0.241103 14.5944L14.5948 0.241097C14.9162 -0.0803657 15.4374 -0.0803657 15.7589 0.241097C16.0804 0.56256 16.0804 1.08373 15.7589 1.40539L1.40543 15.7585C1.24409 15.9188 1.03333 16 0.822764 16Z"
        fill="#A5A5A5"
      />
      <path
        d="M15.1774 16C14.9667 16 14.7561 15.9198 14.5958 15.7585L0.241103 1.40539C-0.0803677 1.08373 -0.0803677 0.56256 0.241103 0.241097C0.562574 -0.0803657 1.08376 -0.0803657 1.40543 0.241097L15.7589 14.5944C16.0804 14.9159 16.0804 15.437 15.7589 15.7585C15.5976 15.9188 15.387 16 15.1774 16Z"
        fill="#A5A5A5"
      />
    </Svg>
  );
};

export default Icon;
